import { FC, PropsWithChildren } from "react";
import { Span } from "@goodfill/ui-components";

type RegulatoryFieldProps = PropsWithChildren<{
  label: string;
}>;

export const RegulatoryField: FC<RegulatoryFieldProps> = ({ children, label }) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center gap-2 md:gap-4 border-b border-neutral-110">
      <div className="field-label">
        <Span font="light" size="sm">
          {label}
        </Span>
      </div>
      {children}
    </div>
  );
};
